import 'lightcase/src/js/lightcase';

/**
 *
 */
class Lightbox {
  /**
   *
   */
  constructor() {
    this.config = {
      maxWidth: 1920,
      maxHeight: 1200,
      shrinkFactor: 0.9,
      video: {
        width: 1200,
        height: 675,
      },
      iframe: {
        width: 1200,
        height: 675,
      },
    };
  }

  /**
   * Initializes the lightboxes on the website
   */
  init() {
    $(() => {
      $('a[data-rel^=lightcase]').lightcase(this.config);
    });
  }
}

export default Lightbox;
